import { render, staticRenderFns } from "./IntegralPrizeModal.vue?vue&type=template&id=3beb76d5&scoped=true&"
import script from "./IntegralPrizeModal.vue?vue&type=script&lang=js&"
export * from "./IntegralPrizeModal.vue?vue&type=script&lang=js&"
import style0 from "./IntegralPrizeModal.vue?vue&type=style&index=0&id=3beb76d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb76d5",
  null
  
)

export default component.exports